const STATE_NAMES = {
  user: "user-store",
  workspace: "workspace-store",
  manager: "manager-store",
  category: "category-store",
  faq: "faq-store",
  signIn: "sign-in-store",
  language: "language-store"
};

export default STATE_NAMES;
